import type { ReactNode } from 'react';

import {
  ListingViewFooterHolder,
  ListingViewFooterWrapper,
} from './ListingViewFooter.styled';

type Props = {
  children: ReactNode;
  hiddenOnDesktop?: boolean;
};

export function ListingViewFooter({ children, hiddenOnDesktop }: Props) {
  return (
    <ListingViewFooterHolder $hiddenOnDesktop={Boolean(hiddenOnDesktop)}>
      <ListingViewFooterWrapper>{children}</ListingViewFooterWrapper>
    </ListingViewFooterHolder>
  );
}
